module.exports = __webpack_public_path__ + "media/images/activeIconprofessionaldevelopment-62715016.png";